import React, { useState } from 'react';
import FormContainer, { styles } from '../../../forms/FormContainer/FormContainer';
import ImageUpload from '../../../forms/ImageUpload';
import Navigation from '../Navigation';
import { useFormik } from 'formik';
import * as yup from 'yup';
import FormField from '../../../forms/FormField/FormField';
import Notice from '../Notice';
import submitForm from '../../../../services/submitAdvertForm';

const validationSchema = yup.object({
    title: yup.string().required('Job title is required.'),
    salary: yup.string().required('Please enter a salary or range.'),
    sector: yup.string().required('Please enter a sector.'),
    location: yup.string().required('Please enter a location.'),
    url: yup.string(),
    description: yup.string().required('Please enter a description.'),
    images: yup.array()
        .test('fileSize', 'Images must be less than 8MB.', value => {
            let valid = true;
            value?.forEach(file => {
                if (file.size > 8 * 1024 * 1024) {
                    valid = false;
                }
            });
            return valid;
        })
        .test('fileType', 'Unsupported file type, only JPG, PNG and GIF are accepted.', value => {
            const supportedTypes = ['image/png', 'image/jpeg', 'image/gif'];
            let valid = true;
            value?.forEach(file => {
                if (!supportedTypes.includes(file.type)) {
                    valid = false;
                }
            });
            return valid;
        }),
});


export default function ClassifiedForm({ adPrice, setJourney }) {
    const [loading, setLoading] = useState(false);
    const formik = useFormik({
        initialValues: {
            images: [],
            title: '',
            salary: '',
            sector: '',
            location: '',
            description: '',
            url: '',
            adLevel: adPrice,
        },
        validationSchema: validationSchema,
        onSubmit: values => submitForm(values, setJourney, 'job', setLoading),
    });

    return (
        <FormContainer>
            <form className={loading ? styles.loading : ""} onSubmit={formik.handleSubmit}>
                <h2>Post a job</h2>
                <ImageUpload formik={formik} />
                <FormField label="Job title:" type="text" name="title" formik={formik} />
                <FormField label="Salary:" type="text" name="salary" formik={formik} />
                <FormField label="Sector:" type="text" name="sector" formik={formik} />
                <FormField label="Location:" type="text" name="location" formik={formik} />
                <FormField label="Description:" type="textarea" name="description" formik={formik} />
                <FormField label="Link to original advert:" type="text" name="url" formik={formik} />
                <FormField label="Advert Level:" type="select" name="adLevel" formik={formik} options={['Standard', 'Premium']} />
                <Navigation setJourney={setJourney} formik={formik} />
                <Notice formik={formik} />
            </form>
        </FormContainer>
    )
}
